/**
 * @module UILayer
 *
 * @description Loads All the UI Layers and routing
 *
 */
import React from 'react';
import './styles.scss';
import ModalLoader from './ModalsLoader';
import OverlayComponents from '../OverlayComponets';
import RoomRoutes from '../RoomRoutes';
import FontsLoader from './FontsLoader';
import PreSceneLoader from './PreSceneLoader';
import SceneOverlays from './SceneOverlays';
import SceneTransitionLoader from './SceneTransitionLoader';

const UILayer = () => {
	console.log('%c UILayer rerendered', 'color:yellow');
	return (
		<>
			<RoomRoutes />
			<SceneTransitionLoader />
			<OverlayComponents />
			<SceneOverlays />
			<PreSceneLoader />
			<ModalLoader />
			<FontsLoader />
		</>
	);
};

export default UILayer;
